module.exports = ['lots.search.form.exactmatch.m1'];
